import { createContext } from 'react';

const TestPanelContext = createContext({});

export default TestPanelContext;
